import { render } from "./EstabelecimentoDashPage.vue?vue&type=template&id=51ebea03&scoped=true"
import script from "./EstabelecimentoDashPage.vue?vue&type=script&lang=js"
export * from "./EstabelecimentoDashPage.vue?vue&type=script&lang=js"

import "./EstabelecimentoDashPage.vue?vue&type=style&index=0&id=51ebea03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ebea03"]])

export default __exports__